
import {PERCORSOTARIFFA} from './PercorsoTariffaTypes'

export const changePercorsoTariffa = percorsoTariffa => {
    return {
        type: PERCORSOTARIFFA,
        load: percorsoTariffa
    }
}
export const selectNewPercorsoTariffa = (percorsoTariffa) => {

    return (dispatch) => {
        dispatch(changePercorsoTariffa(percorsoTariffa))
    }

}